<template>
  <div class="page box">
    <div  >
  <!-- <van-tabs class="activetabs" v-model:active="active" @change="activeTabs" animated shrink v-if="childInfoList.length>0">
  <van-tab v-for="(childItem,childindex) in childInfoList" :title="childItem.studentName" :key="childindex">

   

  </van-tab>
</van-tabs>   -->
<van-sticky class="sticky">
<div style="display: none;">
<studentTitleCard  isChange @change="studentChange"/>
</div>
</van-sticky>
       <div class="center"  v-for="(item,i) in homeworkList" :key="i">
    <div >
      <van-row gutter="10">
     
      <van-col span="17" class="text_l">
        <div style="display:flex;align-items: center;height:8vh;">
          <div class="center_name">{{item.name}}</div>
        
        </div>
        <div  style="display:flex;align-items: center;margin-bottom: 4px;">
          <!-- <van-tag plain  type="success">{{['已结束','进行中'][+item.status]}}</van-tag> -->
          <van-tag plain  type="success" size="mini" style="margin-right: 4px;">{{['未做答','已作答'][+item.type]}}</van-tag>
           <van-tag plain  type="success" size="mini">{{['已失效','有效'][+item.ifActive]||'作废'}}</van-tag>
          </div>
        <div style="margin-bottom:10px;">
          <span style="color: rgba(0, 0, 0, 0.4);">时间</span>
           {{item.startTime||''}} ~ {{item.endTime||''}}</div>
      
      </van-col>
       <van-col span="7" class="text_l"  style="display:flex;align-items: center;height:8vh;">
        <van-button type="info" v-if="!+item.type" :disabled='!+item.ifActive||!!+item.type' style="border-radius: 10px;margin-top:10px;width:85%" size="mini" @click="onAddAppoint(item)">操作</van-button>
        <van-button type="info" v-else style="border-radius: 10px;margin-top:10px;width:85%" size="mini" @click="onAddAppoint(item)">查看</van-button>
      </van-col>
    </van-row>
    <!-- 0,未做答,1,已作答 -->
    <div  style="margin-top:10px;">
     
        <div class="project_ul" style="margin-top:10px;">
          <!-- item.homeworkWeekList -->
            <div v-for="(itemc,ic) in item.homeworkWeekList"  :key='ic'  class="Week_li">
            <div > {{weekFil[itemc.week]}} </div>
              <img src="@/assets/image/已测.png" alt="" width="100%" v-if="!!+itemc.isHaveScore" class="isHaveScore">
            </div>
        </div>
        
        <!-- <div class="project_baogao"  @click="onReport(item)"> 体测报告 <van-icon name="arrow" /></div> -->
    </div>
    <!-- <van-cell style="text-align: center;" title="体测报告" is-link  @click="onReport(item)"/> -->

    </div>



    </div>

    </div>

  </div>

</template>

<script>
import CustomButton from "@/components/CustomButton.vue";
import { getChildInfoList} from "@/api/studentBind.js";
import { checkOrder,getHealthTestBySnCode} from "@/api/surveyMgt.js";
import studentTitleCard from "@/components/studentTitleCard.vue";
 import { setSession ,getSession} from "@/utils/cookie";

import store from '@/store'
export default {
data () {
    return {
        childInfoList:[],
        studentInfo:{},
        active:'0',
        homeworkList:[
          //  { homeName:'学生健康征询单',startDate: "2024-03-01",endDate: "2024-12-24",status:'1'},
          //  { homeName:'学生健康征询单',startDate: "2023-03-01",endDate: "2023-12-24",status:'0'},
        ],
        weekFil:['','周一','周二','周三','周四','周五','周六','周日'],
        onStudentInfo:{}
    }
},
components: {
  CustomButton ,
  studentTitleCard
},
mounted () {
    this.init()
    this.onStudentInfo =JSON.parse(localStorage.getItem('studentTitleCard'))
    console.log(this.onStudentInfo);
    
},
methods:{
  studentChange(val){
    console.log('studentChange',val);
    
  this.onStudentInfo =val
  this.getHealthTestBySnCode()
//   this.checkOrder()
  },
  onReport(item){
      let data = JSON.stringify({...this.onStudentInfo,
           termName: item.name,
      termCode:item.code,
      })
      
        this.$router.push({path:'fitnessReport',query:{data:data}})
  },
    onAddAppoint(item){
       let data = {
            id:item.id,
            name:item.name,
            termCode:item.termCode,
            termName:item.termName,
            healthList:item.healthList,
            type:item.type,
            ifActive:item.ifActive,

            snCode:this.onStudentInfo.snCode,
            schoolCode:this.onStudentInfo.schoolCode,
            studentName:this.onStudentInfo.studentName,
          }
      console.log('data',data);
      if (item.healthAnswerNoteList&&item.healthAnswerNoteList.length>0) {
        data.healthList = item.healthAnswerNoteList
      }

        this.$router.push({path:'surveyMgtInfo',query:{data:JSON.stringify(data)}})
    },
     activeTabs(){
         this.getHealthTestBySnCode()
         this.checkOrder()
    },
    init(){
        //   getChildInfoList({status:'1'}).then(res=>{
        // console.log(res);
        // this.childInfoList = res.data.data||[]
        // })
      
    },
    checkOrder(){
        checkOrder({
            snCode:this.onStudentInfo.snCode,
            schoolCode:this.onStudentInfo.schoolCode,
          }).then(res=>{
            // 检查是否有准考证
            console.log(res);
            if (!+res.data.body) {
                // 没有准考证
                this.$dialog
                .alert({
                message: '请先申请电子准考证！！',
                showCancelButton: false
                }).then(() => {
                    this.$router.push({path:'admissionTicket'})
                })
        
            }   
            // res.body
          })
    },
    getHealthTestBySnCode(){
        getHealthTestBySnCode({
            snCode:this.onStudentInfo.snCode,
            schoolCode:this.onStudentInfo.schoolCode,
          }).then(res=>{
            console.log(res);
         
            this.homeworkList = res.data.body||[]
          })
    },
    OnaddFaceIn(){
        if (!this.studentInfo.faceData||this.studentInfo.faceData=='') {
            this.$notify({ type: "danger", message: '请拍摄证件照！' });
            return
        }
        this.$dialog
        .alert({
          message: '是否确认生成准考证?',
          showCancelButton: true
        })
        .then(() => {
            insertIntoFaceData(this.studentInfo).then(Res=>{
            this.$notify({ type: "success", message: '生成成功！' });
            this.$router.back(-1)
            })
        })
        .catch(() => {
          // on cancel
        })
    },
    goAiFace(){
        this.$router.push({path:'aiFace'})
    }
}
}
</script>

<style lang="less" scoped>
.box{
    padding: 5px;
    font-size: 3vw;
}
.text_l{
    text-align: left;
    text-overflow:ellipsis;
    overflow:hidden;
    // white-space:nowrap;
    
}
.noActiceCard{
    position: relative;
 .ifActiveBox{
          position: absolute;
          right: 0px;
          top: 10px;
          transform: rotate(45deg);
        }
}

.project_title{
  font-size: 3.8vw;
  text-align: left;
  margin-bottom: 10px;
}
.project_ul{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .project_li{
    position: relative;
    width: 30%;
    height: 33px;
    margin-right: 3%;
    line-height: 33px;
    border-radius: 9px;
    font-size: 3.3vw;
    margin-bottom: 10px;
    background: rgba(0, 0, 0, 0.04);
   
}
.Week_li{
   position: relative;
    width: 12%;
    height: 30px;
    margin-right: 1%;
    line-height: 30px;
    border-radius: 9px;
    font-size: 3vw;
    margin-bottom: 10px;

    background: rgba(0, 0, 0, 0.04);
}
 .isHaveScore{
      position: absolute;
      top: 0;
      right: 0;
      width: 20%;
    }

 .tag_span_green{
                border: 1px solid rgb(61, 224, 61);
    border-radius: 8px;
                color: #37cf18;
                text-align: center;
                width: 90%;
                overflow: hidden;
            }
            .tag_span_grey{
                border: 1px solid rgb(141, 135, 135);
    border-radius: 8px;
                color: #6a6d69;
                text-align: center;
                width: 90%;
                overflow: hidden;
            }
}
.project_baogao{
  text-align: center;
  font-size: 3.5vw;
  margin: 10px 0;
  color: #3c69e6;

}
 .center{
        // height: 250px;
        padding:12px;
        position: relative;
        background-color: #fff;
        border-radius: 10px;
        // border: 1px solid #ccc;
        margin: 8px;
        box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);
        .center_name{
          font-size: 4.8vw;
          font-weight: 600;
          margin-right: 8px;
          // margin: 5px 10px 15px 0px;
        }
        .center_value{
            color: #bbb;
        }
    

        .van_tag{
            // margin-left: 20px;
            text-align: center;
           
            /deep/ .van-grid-item__content{
                padding: 0px;
               border-radius: 8px;

            }
        }

        .center_text{
            text-align: left;
            font-size: 13px;
            margin-bottom: 50px;
            .center_text_title{
                font-size: 25px;
                font-weight: 700;
            }
        }
        .center_footer{
            text-align: left;
            .center_footer_title{
                font-size: 20px;
                font-weight: normal;
            }
            
            .center_footer_left{

            }
            .center_footer_right{
                .center_footer_right_value{
                font-size: 20px;
                height: 50px;
                line-height: 50px;
                border: 1px solid #bbb;
                margin-top: 10px;
                text-align: center;

            }
            }
        }
    }
</style>